import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, Row } from 'react-bootstrap';
//components
import Pagination from './Pagination';
import NoResults from './NoResults';

const FilteredResults = ({ children, noResults, page, totalPages, changePage, isLoading, data }) => {
  const renderBody = () => {
    if (isLoading) {
      return (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" style={{ color: '#0069d9' }} />
        </div>
      );
    } else if (noResults) {
      return <NoResults className='noFavorites' />;
    } else {
      return children;
    }
  };
  return (
    <>
      <Row className="mx-2">{renderBody()}</Row>
      {page && totalPages && <Pagination changePage={changePage} page={page} totalPages={totalPages} />}
    </>
  );
};

FilteredResults.propTypes = {
  children: PropTypes.any,
  data: PropTypes.bool.isRequired,
  noResults: PropTypes.bool,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default FilteredResults;
